import classNames from 'clsx';
import type { Config as FormConfig } from 'final-form';
import type { ReactNode } from 'react';
import React from 'react';
import type { FormProps, FormRenderProps } from 'react-final-form';
import { withTypes } from 'react-final-form';

import { FormMethod } from '@swf/core/enums';

import styles from './Form.scss';

export interface Props<T> extends FormProps<T>, FormConfig<T> {
  children?: React.ReactNode;
  className?: string;
  render?(params: FormRenderProps<T>): ReactNode;
}

function createForm<FormValues = never>() {
  const ReactFinalForm = withTypes<FormValues>().Form;

  return (props: Props<FormValues>) => (
    <ReactFinalForm
      {...props}
      render={(params) => (
        <form
          method={FormMethod.Post}
          onSubmit={params.handleSubmit}
          className={classNames(props.className, styles.form)}
        >
          {props.children}
          {props.render && props.render(params)}
        </form>
      )}
    />
  );
}

export default createForm;
